<div class="basic-info" [formGroup]="group">
  <h3>User information</h3>
  <mat-form-field>
    <mat-label>User type</mat-label>
    <mat-select formControlName="userType">
      <mat-option value="Internal">Internal</mat-option>
      <mat-option value="External">External</mat-option>
    </mat-select>
    @if (!group.get('id')?.value) {
      <mat-hint>You can only create external user via this form</mat-hint>
    } @else if (!isAdmin) {
      <mat-hint>Only admin can change user type</mat-hint>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>First name</mat-label>
    <input matInput formControlName="firstName" />
    @if (group.get('firstName')?.hasError('required')) {
      <mat-error>First name is required</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Last name</mat-label>
    <input matInput formControlName="lastName" />
    @if (group.get('lastName')?.hasError('required')) {
      <mat-error>Last name is required</mat-error>
    }
  </mat-form-field>
  @let emailControl = group.get('email');
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Email</mat-label>
    <input matInput formControlName="email" />
    @if (emailControl?.hasError('required')) {
      <mat-error>Email is required</mat-error>
    }
    @if (emailControl?.hasError('email')) {
      <mat-error>Wrong email format</mat-error>
    }
    @if (emailControl?.disabled) {
      <mat-hint>Email cannot be changed</mat-hint>
    }
  </mat-form-field>
  @if (emailControl?.hasError('emailExists')) {
    <div class="basic-info__email-warning">
      <mat-icon>warning</mat-icon>
      <span>A user with this email address already exists. Please verify before continuing.</span>
    </div>
  }
  @if (group.get('mainPartyName')?.value) {
    <div class="basic-info__main-party">
      Main party:
      <div class="basic-info__main-party--name">
        <span class="label" [appEllipsisTooltip]="group.get('mainPartyName')?.value ?? ''">
          {{ group.get('mainPartyName')?.value }}</span
        >
        <mat-icon (click)="onMainPartyCloseClick()">close</mat-icon>
      </div>
    </div>
  } @else {
    <app-party-selector
      label="Search for main party"
      [relatedControl]="group.get('mainPartyNumber')"
      (selectedParty)="onPartySelected($event)"></app-party-selector>
  }
  <mat-checkbox formControlName="portalAccess">Enable portal access</mat-checkbox>
</div>
